import type { Country, Labels } from "react-phone-number-input";
import deLabels from "react-phone-number-input/locale/de.json";
import enLabels from "react-phone-number-input/locale/en.json";
import frLabels from "react-phone-number-input/locale/fr.json";
import itLabels from "react-phone-number-input/locale/it.json";
import esLabels from "react-phone-number-input/locale/es.json";

/** Keep in sync with @patient-watch/i18n LOCALE_PHONE_COUNTRY. */
const LOCALE_PHONE_COUNTRY: Record<string, Country> = {
    "en-GB": "GB",
    "en-US": "US",
    "de-DE": "DE",
    "da-DK": "DK",
    "fr-FR": "FR",
    "it-IT": "IT",
    "es-ES": "ES",
};

export function normaliseLocaleTag(tag: string | null | undefined): string | null {
    if (!tag || typeof tag !== "string") return null;
    const trimmed = tag.trim();
    if (!trimmed) return null;
    if (trimmed in LOCALE_PHONE_COUNTRY) return trimmed;
    const lower = trimmed.toLowerCase();
    if (lower === "en-us") return "en-US";
    if (lower === "en" || lower.startsWith("en-")) return "en-GB";
    if (lower === "de" || lower.startsWith("de-")) return "de-DE";
    if (lower === "da" || lower.startsWith("da-")) return "da-DK";
    if (lower === "fr" || lower.startsWith("fr-")) return "fr-FR";
    if (lower === "it" || lower.startsWith("it-")) return "it-IT";
    if (lower === "es" || lower.startsWith("es-")) return "es-ES";
    return null;
}

export function localeToPhoneCountry(locale: string | null | undefined): Country {
    const normalized = normaliseLocaleTag(locale);
    return normalized ? (LOCALE_PHONE_COUNTRY[normalized] ?? "GB") : "GB";
}

/** Localised country names for the phone country picker (react-phone-number-input labels). */
export function localeToPhoneLabels(locale: string | null | undefined): Labels {
    const normalized = normaliseLocaleTag(locale);
    if (normalized === "de-DE") return deLabels;
    if (normalized === "fr-FR") return frLabels;
    if (normalized === "it-IT") return itLabels;
    if (normalized === "es-ES") return esLabels;
    return enLabels;
}

/** Locale tag passed to react-phone-number-input `locales` prop. */
export function localeToPhoneUiLocale(locale: string | null | undefined): string {
    const normalized = normaliseLocaleTag(locale);
    if (normalized === "de-DE") return "de";
    if (normalized === "fr-FR") return "fr";
    if (normalized === "it-IT") return "it";
    if (normalized === "es-ES") return "es";
    return "en";
}
